import { accordion } from "./accordion/accordion";
import { autocomplete } from "./autocomplete/autocomplete";
import { avatar } from "./avatar/avatar";
import { badge } from "./badge/badge";
import { breadcrumb } from "./breadcrumb/breadcrumb";
import { button } from "./button/button";
import { card } from "./card/card";
import { carousel } from "./carousel/carousel";
import { cascadeselect } from "./cascadeselect/cascadeselect";
import { checkbox } from "./checkbox/checkbox";
import { chip } from "./chip/chip";
import { colorpicker } from "./colorpicker/colorpicker";
import { confirmdialog } from "./confirmdialog/confirmdialog";
import { contextmenu } from "./contextmenu/contextmenu";
import { datatable } from "./datatable/datatable";
import { datepicker } from "./datepicker/datepicker";
import { dialog } from "./dialog/dialog";
import { divider } from "./divider/divider";
import { drawer } from "./drawer/drawer";
import { editor } from "./editor/editor";
import { emptystate } from "./emptystate/emptystate";
import { fileupload } from "./fileupload/fileupload";
import { floatlabel } from "./floatlabel/floatlabel";
import { galleria } from "./galleria/galleria";
import { iconfield } from "./iconfield/iconfield";
import { inplace } from "./inplace/inplace";
import { inputgroup } from "./inputgroup/inputgroup";
import { inputnumber } from "./inputnumber/inputnumber";
import { inputtext } from "./inputtext/inputtext";
import { listbox } from "./listbox/listbox";
import { menu } from "./menu/menu";
import { message } from "./message/message";
import { multiselect } from "./multiselect/multiselect";
import { overlaybadge } from "./overlaybadge/overlaybadge";
import { pageheader } from "./pageheader/pageheader";
import { paginator } from "./paginator/paginator";
import { panel } from "./panel/panel";
import { password } from "./password/password";
import { picklist } from "./picklist/picklist";
import { popover } from "./popover/popover";
import { primitive } from "./primitive/primitive";
import { progressbar } from "./progressbar/progressbar";
import { progressspinner } from "./progressspinner/progressspinner";
import { radiobutton } from "./radiobutton/radiobutton";
import { rating } from "./rating/rating";
import { rowdetails } from "./rowdetails/rowdetails";
import { select } from "./select/select";
import { selectbutton } from "./selectbutton/selectbutton";
import { selectlist } from "./selectlist/selectlist";
import { semantic } from "./semantic/semantic";
import { sidenav } from "./sidenav/sidenav";
import { skeleton } from "./skeleton/skeleton";
import { slider } from "./slider/slider";
import { splitbutton } from "./splitbutton/splitbutton";
import { splitter } from "./splitter/splitter";
import { stepper } from "./stepper/stepper";
import { tabs } from "./tabs/tabs";
import { tag } from "./tag/tag";
import { textarea } from "./textarea/textarea";
import { tieredmenu } from "./tieredmenu/tieredmenu";
import { timeline } from "./timeline/timeline";
import { toast } from "./toast/toast";
import { togglebutton } from "./togglebutton/togglebutton";
import { toggleswitch } from "./toggleswitch/toggleswitch";
import { toolbar } from "./toolbar/toolbar";
import { tooltip } from "./tooltip/tooltip";
import { tree } from "./tree/tree";
import { treeselect } from "./treeselect/treeselect";
import { treetable } from "./treetable/treetable";
import type { DeepPartial } from "ts-essentials";

export const Ankaadia = {
  semantic,
  primitive,
  components: {
    accordion,
    autocomplete,
    avatar,
    badge,
    breadcrumb,
    button,
    card,
    carousel,
    cascadeselect,
    checkbox,
    chip,
    colorpicker,
    confirmdialog,
    contextmenu,
    datatable,
    datepicker,
    dialog,
    divider,
    drawer,
    editor,
    emptystate,
    fileupload,
    floatlabel,
    galleria,
    iconfield,
    inplace,
    inputgroup,
    inputnumber,
    inputtext,
    listbox,
    menu,
    message,
    multiselect,
    overlaybadge,
    pageheader,
    paginator,
    panel,
    password,
    picklist,
    popover,
    progressbar,
    progressspinner,
    radiobutton,
    rating,
    rowdetails,
    select,
    selectbutton,
    selectlist,
    sidenav,
    skeleton,
    splitbutton,
    splitter,
    stepper,
    tabs,
    tag,
    textarea,
    tieredmenu,
    timeline,
    toast,
    togglebutton,
    toggleswitch,
    toolbar,
    tooltip,
    tree,
    treeselect,
    treetable,
    slider,
  },
};
export type AnkaadiaPresetOverride = DeepPartial<typeof Ankaadia>;
